import { useState, useCallback } from 'react';

export function useModalRegistry() {
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showCreditsModal, setShowCreditsModal] = useState(false);
  const [showAllowedUsersModal, setShowAllowedUsersModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showAccountDeletionModal, setShowAccountDeletionModal] = useState(false);
  const [showExportProModal, setShowExportProModal] = useState(false);
  const [showCommandPalette, setShowCommandPalette] = useState(false);
  const [showShortcutsHelpModal, setShowShortcutsHelpModal] = useState(false);
  const [showUserProfileModal, setShowUserProfileModal] = useState(false);
  const [showCreditsAndHelpModal, setShowCreditsAndHelpModal] = useState(false);
  const [showQuickAddTaskModal, setShowQuickAddTaskModal] = useState(false);
  const [showOnboardingWizard, setShowOnboardingWizard] = useState(false);
  const [showGuidedTour, setShowGuidedTour] = useState(false);
  const [showDragDropHint, setShowDragDropHint] = useState(false);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [showExitConfirm, setShowExitConfirm] = useState(false);
  const [showBiographyModal, setShowBiographyModal] = useState(false);

  const isBlockingDialogOpen = Boolean(
    showCommandPalette ||
    showShortcutsHelpModal ||
    showUserProfileModal ||
    showCreditsAndHelpModal ||
    showPrivacyModal ||
    showExportProModal ||
    showAllowedUsersModal ||
    showAccountDeletionModal ||
    showQuickAddTaskModal ||
    showCreditsModal ||
    showOnboardingWizard ||
    showBiographyModal
  );

  const isAnyModalOpen = Boolean(
    isBlockingDialogOpen ||
    showProfileDropdown ||
    showGuidedTour ||
    showExitConfirm
  );

  const closeTopModalOnEscape = useCallback((): boolean => {
    if (showUserProfileModal) {
      setShowUserProfileModal(false);
      return true;
    }
    if (showCreditsAndHelpModal) {
      setShowCreditsAndHelpModal(false);
      return true;
    }
    if (showPrivacyModal) {
      setShowPrivacyModal(false);
      return true;
    }
    if (showExportProModal) {
      setShowExportProModal(false);
      return true;
    }
    if (showCommandPalette) {
      setShowCommandPalette(false);
      return true;
    }
    if (showQuickAddTaskModal) {
      setShowQuickAddTaskModal(false);
      return true;
    }
    if (showProfileDropdown) {
      setShowProfileDropdown(false);
      return true;
    }
    if (showShortcutsHelpModal) {
      setShowShortcutsHelpModal(false);
      return true;
    }
    if (showCreditsModal) {
      setShowCreditsModal(false);
      return true;
    }
    if (showAllowedUsersModal) {
      setShowAllowedUsersModal(false);
      return true;
    }
    if (showAccountDeletionModal) {
      setShowAccountDeletionModal(false);
      return true;
    }
    if (showBiographyModal) {
      setShowBiographyModal(false);
      return true;
    }
    if (showExitConfirm) {
      setShowExitConfirm(false);
      return true;
    }
    return false;
  }, [
    showUserProfileModal,
    showCreditsAndHelpModal,
    showPrivacyModal,
    showExportProModal,
    showCommandPalette,
    showQuickAddTaskModal,
    showProfileDropdown,
    showShortcutsHelpModal,
    showCreditsModal,
    showAllowedUsersModal,
    showAccountDeletionModal,
    showBiographyModal,
    showExitConfirm
  ]);

  return {
    showProfileDropdown,
    setShowProfileDropdown,
    showCreditsModal,
    setShowCreditsModal,
    showAllowedUsersModal,
    setShowAllowedUsersModal,
    showPrivacyModal,
    setShowPrivacyModal,
    showAccountDeletionModal,
    setShowAccountDeletionModal,
    showExportProModal,
    setShowExportProModal,
    showCommandPalette,
    setShowCommandPalette,
    showShortcutsHelpModal,
    setShowShortcutsHelpModal,
    showUserProfileModal,
    setShowUserProfileModal,
    showCreditsAndHelpModal,
    setShowCreditsAndHelpModal,
    showQuickAddTaskModal,
    setShowQuickAddTaskModal,
    showOnboardingWizard,
    setShowOnboardingWizard,
    showGuidedTour,
    setShowGuidedTour,
    showDragDropHint,
    setShowDragDropHint,
    showSearchDropdown,
    setShowSearchDropdown,
    showExitConfirm,
    setShowExitConfirm,
    showBiographyModal,
    setShowBiographyModal,
    isBlockingDialogOpen,
    isAnyModalOpen,
    closeTopModalOnEscape
  };
}
